export const SET_SAVED_OPTIONS = "SET_SAVED_OPTIONS";
export const SET_OPTIONS = "SET_OPTIONS";
export const ADD_OR_UPDATE_OPTION = "ADD_OR_UPDATE_OPTION";
export const REMOVE_OPTION = "REMOVE_OPTION";
export const SET_SEARCH_TERM = "SET_SEARCH_TERM";
export const SET_SAVING = "SET_SAVING";
export const SET_SHOW_SUCCESS_ALERT = "SET_SHOW_SUCCESS_ALERT";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
export const SET_MODAL_USE = "SET_MODAL_USE";
